































import {Component, Vue} from "vue-property-decorator";
import PortalDate from "@/components/common/PortalDate.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import WalletService from "@/services/WalletService";
import {ReversePayload} from "@/dto/wallet/WalletDTOs";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";

@Component({
  components: {
    PortalDate,
    PortalTextarea,
  }
})
export default class WalletReverseModal extends Vue {
  private transactionId: number | null = null;
  private date = "";
  private description = "";

  beforeOpen(event: any) {
    this.transactionId = event.params.transactionId;
    this.date = "";
    this.description = "";
    this.$validator.reset();
  }

  closeModal() {
    this.$modal.hide("wallet-reverse-modal");
  }

  submit() {
    if (!this.transactionId) {
      return;
    }
    const payload = new ReversePayload({
      date: this.date || null,
      description: this.description || null,
    });
    Application.startLoading();
    WalletService.reverse(this.transactionId, payload).then(
        () => {
          Application.stopLoading();
          this.$emit("saved");
          this.closeModal();
        },
        err => processError(err, this),
    );
  }
}
